import { Link } from "react-router-dom";
import WorkCard from "@/components/feature/WorkCard";
import { getHotWorks } from "@/lib/works";

const WORKS = getHotWorks(8);

export default function HotWorks() {
  return (
    <section className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热门影视推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            根据热度与口碑整理的本周热门作品，点击卡片查看剧情详情
          </p>
        </div>
        <Link
          to="/search"
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
        >
          搜索更多
          <i className="ri-search-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 md:gap-5">
        {WORKS.map((work, index) => (
          <div key={work.id} className="animate-fade-up">
            <WorkCard work={work} index={index} />
          </div>
        ))}
      </div>
    </section>
  );
}